export class GetUiDefinitionRequest {
  url: string;
  name: string;
  currentPersonId: string;
  currentVereinId: string;
  currentAnlassId: string;

  constructor(url: string, name: string, currentPersonId: string, currentVereinId: string, currentAnlassId: string) {
    this.url = url;
    this.name = name;
    this.currentPersonId = currentPersonId;
    this.currentVereinId = currentVereinId;
    this.currentAnlassId = currentAnlassId;
  }
}
